import React from 'react';
import './Accueil.css';

const Accueil = () => {
    return (
        <div className="iframe-wrapper">
            <iframe
                className="iframe-landing"
                src="https://centralis.site/?site=centraliseuhideicon"
                title="Centralis"
            />
        </div>
    );
};

export default Accueil;